import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button, Badge, Modal, Spinner, Pagination } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import NoPeanutPolicyListComp from '../../../../components/registrationPacket/NoPeanutPolicyListComp';

const NoPeanutPolicyList = () => {

  useEffect(() => {

  }, []);

  return (
    <Container>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center flex-wrap">
              <div className="header-title mb-2 mb-md-0">
                <h4 className="card-title">No Peanut Policy</h4>
              </div>
              <Link to="/dashboard/no-peanut-policy/add">
                <Button variant="primary">
                  <i className="icon material-symbols-outlined me-1" style={{ verticalAlign: 'middle' }}>add</i>
                  Create New Policy
                </Button>
              </Link>
            </Card.Header>
            <Card.Body>
              <NoPeanutPolicyListComp />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default NoPeanutPolicyList;
